import * as React from 'react';
// import { Form, Input, Button } from '../../modules';
import { Button } from '../../modules';
import Form from '../../../components/FormGenerator/Form';
import { newsletterFields } from '../../../formFields';

interface INewsletterState {
  formFields: any[];
  formValues: any;
}

class NewsletterForm extends React.Component {
  public state: INewsletterState;

  constructor(props: {}) {
    super(props);

    this.state = {
      formFields: newsletterFields,
      formValues: {}
    };
  }

  public handleChange = (value: any, field: string) => {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState = (fields: any) => {
    this.setState({ fields });
  }

  public handleSend(form: any) {
    form.validate((fields: any) => {
      this.setFormState(fields);
    });
  }

  public render() {
    return (
      <div className="form form--newsletter">
        <Form
          fields={this.state.formFields}
          values={this.state.formValues}
          handleChange={this.handleChange}
        >
          {(form: any) => {
            return (
              <Button
                onClick={() => {
                  this.handleSend(form);
                }}
              >
                Odeslat
              </Button>
            );
          }}
        </Form>
      </div>
      // <Form type="newsletter">
      //     <Input type="email" placeholder="E-mail"/>
      //     <Button color="black">Odeslat</Button>
      // </Form>
    );
  }
}

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/modules/Form/Newsletter/index.tsx